import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, Optional } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';

@Directive({
  selector: 'app-map-directions'
})
export class MapDirectionsDirective implements OnChanges, OnDestroy {
  @Input() origin: google.maps.LatLngLiteral | string;
  @Input() destination: google.maps.LatLngLiteral | string;
  @Input() waypoints: google.maps.DirectionsWaypoint[] = [];
  @Input() travelMode: google.maps.TravelMode = google.maps.TravelMode.DRIVING;
  @Input() renderOptions: google.maps.DirectionsRendererOptions;

  private directionsService: google.maps.DirectionsService;
  private directionsRenderer: google.maps.DirectionsRenderer;

  constructor(@Optional() private googleMap: GoogleMap) {
    this.directionsRenderer = new google.maps.DirectionsRenderer();
  }

  ngOnInit() {
    this.directionsService = new google.maps.DirectionsService();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.googleMap && (changes['origin'] || changes['destination'] || changes['waypoints'])) {
      this.updateDirections();
    }
  }

  private updateDirections() {
    if (!this.origin || !this.destination) {
      return;
    }

    const map = this.googleMap.googleMap;
    if (map) {
      this.directionsRenderer.setMap(map);
      if (this.renderOptions) {
        this.directionsRenderer.setOptions(this.renderOptions);
      }

      this.directionsService.route(
        {
          origin: this.origin,
          destination: this.destination,
          waypoints: this.waypoints,
          travelMode: this.travelMode
        },
        (response, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.directionsRenderer.setDirections(response);
          } else {
            console.error('Directions request failed due to ' + status);
          }
        }
      );
    } else {
      setTimeout(() => this.updateDirections(), 100);
    }
  }

  ngOnDestroy() {
    this.directionsRenderer.setMap(null);
  }
}
